<template>
    <div ref="script" />
</template>

<script>
import playerEmbedSrc from '@/utils/config/playerEmbedSrc';

export default {
    props: {
        id: {
            type: [String, Number],
            default: '1:0',
        },
        hash: {
            type: String,
            default: '',
        },
        playerType: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        src: playerEmbedSrc[process.env.MIX_APP_ENV],
    }),

    /**
     * Action after component is mounted.
     */
    mounted() {
        const script = document.createElement('script');

        script.setAttribute('type', 'application/javascript');
        script.setAttribute('async', '');
        script.setAttribute('src', this.src);

        script.dataset.type = this.playerType;
        script.dataset.hash = this.hash;

        if ('track' === this.playerType) {
            script.dataset.track = this.id;
        }

        this.$refs.script.appendChild(script);
    },
};
</script>
